import React from 'react';
import styled from 'styled-components';

const countryCodeToFlag = (countryCode: string): string | undefined => {
  // Base code points for regional indicator symbols
  const base = 127397;

  // Validate country code format (two uppercase letters)
  if (!/^[A-Z]{2}$/.test(countryCode.toUpperCase())) {
    return;
  }

  // Convert country code to uppercase
  const country = countryCode.toUpperCase();

  // Calculate the flag emoji using regional indicator symbols
  const codeArray = Array.from(country).map(
    (char) => base + char.charCodeAt(0)
  );
  return String.fromCodePoint(...codeArray);
};

interface EmojiFlagProps {
  className?: string;
  countryCode: string;
}

const EmojiFlag: React.FC<EmojiFlagProps> = ({ className, countryCode }) => {
  return countryCodeToFlag(countryCode) === undefined ? null : (
    <EmojiFlagWrapper
      className={className || ''}
      aria-label={`Flag for ${countryCode}`}
      role="img"
      aria-hidden="true"
    >
      {countryCodeToFlag(countryCode)}
    </EmojiFlagWrapper>
  );
};

export default EmojiFlag;

const EmojiFlagWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  text-align: center;
  font-size: 16px;
  font-weight: 800;
  line-height: 100%; /* 16px */
  letter-spacing: -0.6px;
  user-select: none;
  pointer-events: none;
`;
